import * as ActionTypes from '../../actions/ActionTypes';
import ArticleFeedbackReportRecord from '../../records/ArticleFeedbackReportRecord';
import { getCountHelpfulRating } from '../../utils/feedbackReportUtils';
export default function articleFeedbackReport(state = new ArticleFeedbackReportRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_ARTICLE_FEEDBACK_REPORT_PENDING:
      return state.merge({
        error: undefined,
        isRequesting: true
      });
    case ActionTypes.FETCH_ARTICLE_FEEDBACK_REPORT_SUCCESS:
      {
        const {
          payload: {
            aggregations,
            count: countTotal
          }
        } = action;
        return state.merge({
          error: undefined,
          isRequesting: false,
          countHelpful: getCountHelpfulRating(aggregations['hs_value'], countTotal),
          countTotal
        });
      }
    case ActionTypes.FETCH_ARTICLE_FEEDBACK_REPORT_ERROR:
      return state.merge({
        error: action.error,
        isRequesting: false
      });
    default:
      return state;
  }
}